<template>
  <div class="content">
    <div class="head">
      <h2>
        クラス {{ classNum }}<span v-if="classMemo"> : </span>{{ classMemo }}
      </h2>
    </div>

    <div class="login">
      <div class="container">
        <transition name="fade">
          <div v-if="info" class="info">{{ infoText }}</div>
        </transition>

        <div class="row">
          <div @click="modalOpen('memo')" class="columns button">メモ変更</div>
          <div @click="modalOpen('st')" class="columns button">生徒数変更</div>
          <div @click="modalOpen('setting')" class="columns button">
            クラス設定変更
          </div>
          <div @click="modalOpen('history')" class="columns button">
            履歴表示
          </div>
          <div @click="change('stReset')" class="columns button">
            クラスをリセット
          </div>
          <div @click="modalOpen('delClass')" class="columns button">
            クラスの削除
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="modal" v-if="modal">
        <p>{{ modalText }}</p>

        <!-- 履歴表示 -->
        <div v-if="rireki">
          <table>
            <thead>
              <tr>
                <th v-for="column in rirekiColumns" :key="column.index">
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="rirekidata in rows">
                <tr :key="rirekidata.index + '_1'">
                  <td rowspan="2">{{ rirekidata.stName }}</td>
                  <td>{{ rirekidata.points }}</td>
                  <td>{{ rirekidata.gachaTimes }}</td>
                  <td>{{ rirekidata.cardTotal }}</td>
                  <td>{{ rirekidata.denwaTotal }}</td>
                  <td>{{ rirekidata.consent }}</td>
                  <td>{{ rirekidata.age }}</td>
                </tr>
                <tr :key="rirekidata.index + '_2'">
                  <td colspan="6">{{ rirekidata.prize }}</td>
                </tr>
              </template>
              <tr class="totalcolumn">
                <td>合計</td>
                <td>{{ totalCoin }}</td>
                <td>{{ totalGacha }}</td>
                <td>{{ totalCard }}</td>
                <td>{{ totalDenwa }}</td>
              </tr>
            </tbody>
          </table>
          <button type="button" @click="modalCancel('modal')">閉じる</button>
        </div>

        <form v-else @submit.prevent="change(modalContent)">
          <!-- メモの変更 -->
          <input type="text" v-model="classMemo" v-if="memo" />

          <!-- 生徒数変更 -->
          <input type="number" v-model="stNum" v-if="st" />

          <!-- クラス設定 -->
          <div v-if="setting">
            <div class="switchArea">
              <span class="label">着目機能</span>
              <input
                type="checkbox"
                id="effect"
                v-model="effect"
                true-value="1"
                false-value="0"
              />
              <label for="effect"><span></span></label>
              <div class="swImg"></div>
            </div>
            <div class="switchArea">
              <span class="label">文字表示</span>
              <label :class="{ selected: easy == '0' }">
                <input type="radio" name="easy" v-model="easy" value="0" />
                通常
              </label>
              <label :class="{ selected: easy == '1' }">
                <input type="radio" name="easy" v-model="easy" value="1" />
                簡単1
              </label>
              <label :class="{ selected: easy == '2' }">
                <input type="radio" name="easy" v-model="easy" value="2" />
                簡単2
              </label>
              <label :class="{ selected: easy == '3' }">
                <input type="radio" name="easy" v-model="easy" value="3" />
                簡単3
              </label>
            </div>
            <div class="switchArea">
              <span class="label">ガチャ確率調整</span>
              <input
                type="checkbox"
                id="rateReg"
                v-model="rateReg"
                true-value="1"
                false-value="0"
              />
              <label for="rateReg"><span></span></label>
              <div class="swImg"></div>
            </div>
            <div class="switchArea">
              <span class="label">電話料金合算払い</span>
              <input
                type="checkbox"
                id="denwaUse"
                v-model="denwaUse"
                true-value="1"
                false-value="0"
              />
              <label for="denwaUse"><span></span></label>
              <div class="swImg"></div>
            </div>
            <div class="switchArea">
              <span class="label">クレジットカード</span>
              <input
                type="checkbox"
                id="creditUse"
                v-model="creditUse"
                true-value="1"
                false-value="0"
              />
              <label for="creditUse"><span></span></label>
              <div class="swImg"></div>
            </div>
          </div>

          <div v-if="err">
            {{ errText }}
          </div>
          <div>
            <button type="button" @click="change(modalContent)">
              変更する
            </button>
            <button type="button" @click="modalCancel('modal')">Cancel</button>
          </div>
        </form>
      </div>
    </transition>

    <transition name="fade">
      <div class="modalCaution" v-if="modalCaution">
        <p v-html="modalText"></p>
        <div>
          <button type="button" v-if="st" @click="change('classReset')">
            変更する
          </button>
          <button type="button" v-if="delClass" @click="del()">削除する</button>
          <button type="button" @click="modalCancel('caution')">Cancel</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  title: "(教師用管理ページ)",
  name: "classroom",
  data() {
    return {
      classNum: "",
      modal: false,
      modalCaution: false,
      modalContent: "",
      modalText: "",
      stNum: 0,
      classMemo: "",
      memo: false,
      st: false,
      setting: false,
      effect: false,
      easy: false,
      rateReg: true,
      denwaUse: false,
      creditUse: false,
      rireki: false,
      rirekiColumns: [
        { label: "名前", field: "stName", type: "number" },
        { label: "保有コイン", field: "points", type: "number" },
        { label: "ガチャ回数", field: "gachaTimes", type: "number" },
        { label: "チケットコード使用金額", field: "cardTotal", type: "number" },
        {
          label: "電話料金合算払い使用金額",
          field: "denwaTotal",
          type: "number",
        },
        { label: "保護者の同意", field: "consent" },
        { label: "年齢確認", field: "age", type: "number" },
      ],
      rows: [],
      totalCoin: "",
      totalGacha: "",
      totalCard: "",
      totalDenwa: "",
      err: false,
      errText: "",
      info: false,
      infoText: "",
      delClass: false,
    };
  },
  beforeCreate() {
    if (!this.$store.state.loggedIn) {
      this.$router.push({ name: "class" });
    }
  },
  created() {
    this.classNum = this.$store.state.classNum;
    axios
      .get(this.$store.state.APIbase + "api/classroom/" + this.classNum)
      .then((res) => {
        this.stNum = parseInt(res.data[0].stNum);
        this.classMemo = res.data[0].classMemo;
        this.denwaUse = res.data[0].denwaUse;
        this.creditUse = res.data[0].creditUse;
        this.effect = res.data[0].effect;
        this.easy = res.data[0].easy;
        this.rateReg = res.data[0].rateReg;
      });
  },
  methods: {
    modalOpen: function (e) {
      this.modalCaution = false;
      this.modalContent = e;
      this.modal = true;
      var self = this;
      if (e == "memo") {
        self.memo = true;
        self.setting = false;
        self.rireki = false;
        self.delClass = false;
        self.modalText = "クラス番号の横にメモを記入できます。";
      } else if (e == "st") {
        self.memo = false;
        self.st = true;
        self.setting = false;
        self.rireki = false;
        self.delClass = false;
        self.modalText = "※生徒の数を変更すると生徒データが消去されます。";
      } else if (e == "setting") {
        self.memo = false;
        self.st = false;
        self.setting = true;
        self.rireki = false;
        self.delClass = false;
        self.modalText = "クラス設定の変更";
      } else if (e == "history") {
        self.memo = false;
        self.st = false;
        self.setting = false;
        self.rireki = true;
        self.delClass = false;
        self.modalText = "クラスの履歴表示";
        axios
          .get(
            self.$store.state.APIbase +
              "api/rireki/" +
              self.$store.state.classNum
          )
          .then((res) => {
            self.rows = res.data;
            self.totalCoin = self.rows.reduce(function (sum, coin) {
              return sum + parseInt(coin.points, 10);
            }, 0);
            self.totalGacha = self.rows.reduce(function (sum, coin) {
              return sum + parseInt(coin.gachaTimes, 10);
            }, 0);
            self.totalCard = self.rows.reduce(function (sum, coin) {
              return sum + parseInt(coin.cardTotal, 10);
            }, 0);
            self.totalDenwa = self.rows.reduce(function (sum, coin) {
              return sum + parseInt(coin.denwaTotal, 10);
            }, 0);
          });
      } else if (e == "delClass") {
        self.modal = false;
        self.modalCaution = true;
        self.memo = false;
        self.st = false;
        self.delClass = true;
        self.modalText =
          "クラスを削除すると生徒データも削除され、元に戻すことができません。<br>本当に削除していいですか？";
      }
    },
    modalCancel: function (e) {
      if (e == "modal") {
        this.modal = false;
      } else if (e == "caution") {
        this.modalCaution = false;
      }
    },
    change: function (e) {
      var self = this;
      if (e == "memo") {
        //クラスメモの更新
        var param = { classMemo: this.classMemo };
        axios
          .put(
            this.$store.state.APIbase + "api/classMemo/" + this.classNum,
            param
          )
          .then(() => {
            self.infoText = "クラスのメモを変更しました。";
            self.info = true;
            self.modal = false;
            setTimeout(function () {
              self.info = false;
            }, 2000);
          });
      } else if (e == "st") {
        //生徒データ消去確認
        if (0 < self.stNum && self.stNum < 51) {
          self.modal = false;
          self.modalCaution = true;
          self.modalText =
            "生徒の数を変更すると生徒データが消去されます。<br>本当に変更していいですか？";
        } else {
          self.err = true;
          self.errText = "生徒数は1から50の間で設定してください。";
        }
      } else if (e == "stReset") {
        //生徒データ消去確認
        self.modal = false;
        self.modalCaution = true;
        self.modalText =
          "クラスをリセットすると生徒データが消去されます。<br>本当に消去していいですか？";
      } else if (e == "classReset") {
        //生徒データの消去
        param = { stNum: this.stNum };
        axios
          .put(
            this.$store.state.APIbase + "api/classReset/" + this.classNum,
            param
          )
          .then((res) => {
            self.infoText = "クラスに" + res.data + "人を作成しました。";
            self.info = true;
            self.modalCaution = false;
            setTimeout(function () {
              self.info = false;
            }, 2000);
          });
      } else if (e == "setting") {
        var settingParam = {
          effect: this.effect,
          easy: this.easy,
          rateReg: this.rateReg,
          denwaUse: this.denwaUse,
          creditUse: this.creditUse,
        };
        axios
          .put(
            this.$store.state.APIbase + "api/classSetting/" + this.classNum,
            settingParam
          )
          .then(() => {
            //クラス設定変更
            self.infoText = "クラス設定を変更しました。";
            self.info = true;
            self.modal = false;
            setTimeout(function () {
              self.info = false;
            }, 2000);
          });
      }
    },
    del: function () {
      axios
        .put(this.$store.state.APIbase + "api/classDelete/" + this.classNum)
        .then(() => {
          this.$store.state.loggedIn = false;
          this.$router.push({ name: "class" });
        });
    },
  },
};
</script>

<style scoped>
.content {
  min-height: 100vh;
  background: #effffb;
}
.head {
  width: 100%;
  height: 50px;
  min-height: 30px;
  background: #9cdee0;
  text-align: center;
}
.login {
  padding-top: 70px;
  background: #effffb;
  box-shadow: 0px -4px 2px rgba(0, 0, 0, 0.5);
  text-align: center;
}
.button {
  padding-top: 10px;
  padding-bottom: 40px;
  transition: all 0.3s;
}
@media (min-width: 700px) {
  .button {
    margin-left: 0;
    margin-right: 3%;
  }
}
.button:hover {
  transform: scale(1.1);
}
.button:active {
  transform: scale(0.9);
}

.info {
  background: #ffd8d8;
  width: 90%;
  margin-left: 5%;
  margin-top: -50px;
  margin-bottom: 20px;
  padding: 5px;
  border-radius: 5px;
}
.modal {
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: #effffb;
  border: solid 2px #299599;
  text-align: center;
  transition: all 1.2s;
  height: 80%;
  overflow: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.modalCaution {
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: #ffefef;
  border: solid 2px #992929;
  text-align: center;
  transition: all 1.2s;
}

table {
  margin-left: auto;
  margin-right: auto;
  font-size: x-small;
}
td,
th {
  padding: 12px 15px !important;
  border: solid 1px #c1c1c1;
}
.totalcolumn th,
.totalcolumn td {
  background: #9cdee0;
}

/* === ボタンを表示するエリア ============================== */
.switchArea {
  line-height: 32px; /* 1行の高さ          */
  letter-spacing: 0; /* 文字間             */
  text-align: center; /* 文字位置は中央     */
  font-size: 13px; /* 文字サイズ         */

  position: relative; /* 親要素が基点       */
  margin: auto; /* 中央寄せ           */
  width: 86px; /* ボタンの横幅       */
  padding-left: 60px;
}

.switchArea .label {
  float: left;
  margin-left: -110px;
}

/* === チェックボックス ==================================== */
.switchArea input[type="checkbox"] {
  display: none; /* チェックボックス非表示 */
}
.switchArea input[type="radio"] {
  display: none; /* チェックボックス非表示 */
}

/* === チェックボックスのラベル（標準） ==================== */
.switchArea label {
  display: block; /* ボックス要素に変更 */
  box-sizing: border-box; /* 枠線を含んだサイズ */
  height: 32px; /* ボタンの高さ       */
  border: 2px solid #999999; /* 未選択タブのの枠線 */
  border-radius: 16px; /* 角丸               */
  background: #fff;
}

/* === チェックボックスのラベル（ONのとき） ================ */
.switchArea input[type="checkbox"]:checked + label {
  border-color: #ff9999; /* 選択タブの枠線     */
}
.selected {
  border-color: #ff9999 !important;
  color: #ff9999; /* 選択タブの枠線     */
}

/* === 表示する文字（標準） ================================ */
.switchArea label span:after {
  content: "OFF"; /* 表示する文字       */
  padding: 0 0 0 19px; /* 表示する位置       */
  color: #999999; /* 文字色             */
}

/* === 表示する文字（ONのとき） ============================ */
.switchArea input[type="checkbox"]:checked + label span:after {
  content: "ON"; /* 表示する文字       */
  padding: 0 19px 0 0; /* 表示する位置       */
  color: #ff9999; /* 文字色             */
}
/* === 丸部分のSTYLE（標準） =============================== */
.switchArea .swImg {
  position: absolute; /* 親要素からの相対位置*/
  width: 24px; /* 丸の横幅           */
  height: 24px; /* 丸の高さ           */
  background: #999999; /* カーソルタブの背景 */
  top: 4px; /* 親要素からの位置   */
  left: 64px; /* 親要素からの位置   */
  border-radius: 12px; /* 角丸               */
  transition: 0.2s; /* 滑らか変化         */
}

/* === 丸部分のSTYLE（ONのとき） =========================== */
.switchArea input[type="checkbox"]:checked ~ .swImg {
  transform: translateX(54px); /* 丸も右へ移動       */
  background: #ff9999; /* カーソルタブの背景 */
}
</style>
